import React from 'react'
import styles from './Switch.module.css'

const Switch = ({ value, beforeText, afterText, onChange, disabled = false }) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!value)
    }
  }

  return (
    <div className={styles.container} onClick={handleToggle}>
      {beforeText && <div className={styles.beforeText}>{beforeText}</div>}

      <button
        type="button"
        className={`${styles.switch} ${value ? styles.on : styles.off} ${disabled ? styles.disabled : ''}`}
        aria-checked={value}
        role="switch"
        disabled={disabled}
      >
        <span className={styles.handle} />
      </button>
      {afterText && <div className={styles.afterText}>{afterText}</div>}
    </div>
  )
}

export default Switch
